import { Component, Input, OnInit } from '@angular/core';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup } from '@angular/forms';
import { FieldError, getFormErrors } from '@core/utils/form-utils';
import { KeyValuePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'shared-form-error-alert[form]',
    imports: [NgbAlert, KeyValuePipe, TranslatePipe],
    template: `
        @if (formErrors.length > 0) {
            <ngb-alert type="danger" [dismissible]="false" class="d-flex align-items-center gap-1">
                <ul class="mb-0">
                    @for (formError of formErrors; track i; let i = $index) {
                        <li>
                            <b>{{ (getTradPrefix() + formError.field) }} : </b>
                            <ol>
                                @for (error of (formError.errors | keyvalue); track error.key) {
                                    @if (error.key === 'api') {
                                        @for (message of error.value; track $index) {
                                            <li>{{ message }}</li>
                                        }
                                    } @else {
                                        <li>{{ 'errors.form.' + error.key | translate: error.value }}</li>
                                    }
                                }
                            </ol>
                        </li>
                    }
                </ul>
            </ngb-alert>
        }
    `
})
export class FormErrorAlert implements OnInit {
    @Input() tradPrefix: string = '';
    @Input() form!: UntypedFormGroup;

    formErrors: FieldError[] = [];

    ngOnInit() {
        this.formErrors = getFormErrors(this.form);
        this.form.valueChanges.subscribe(() => {
            this.formErrors = getFormErrors(this.form);
        });
        this.form.statusChanges.subscribe(() => {
            this.formErrors = getFormErrors(this.form);
        });
    }

    getTradPrefix(): string {
        if (!this.tradPrefix) {
            return '';
        }

        if (this.tradPrefix.endsWith('.')) {
            return this.tradPrefix;
        }

        return (this.tradPrefix + '.')
    }
}
